// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__vojGq","loadingText":"Loader_loadingText__URtw4","container":"Loader_container__X02md","loaderDots":"Loader_loaderDots__PHWk1","l14":"Loader_l14__o2AXt"};